// Press-Squish + Hover-Lift auf jedem Button — bewusst UNABHÄNGIG von
// prefers-reduced-motion (im Gegensatz zu red/Press.usePress). Für Wizard/Picker,
// wo der User explizit Feedback beim Drücken UND beim Drüberfahren wünscht.

import { useState } from 'react';

export default function Tap({ children, onClick, disabled = false, scale = 0.95, hoverScale = 1.03, style = {}, ...rest }) {
  const [down, setDown] = useState(false);
  const [hover, setHover] = useState(false);
  const transform = disabled ? 'scale(1)' : down ? `scale(${scale})` : hover ? `scale(${hoverScale})` : 'scale(1)';
  return (
    <button
      onClick={disabled ? undefined : onClick}
      onPointerEnter={() => { if (!disabled) setHover(true); }}
      onPointerDown={() => { if (!disabled) setDown(true); }}
      onPointerUp={() => setDown(false)}
      onPointerLeave={() => { setDown(false); setHover(false); }}
      onPointerCancel={() => { setDown(false); setHover(false); }}
      disabled={disabled}
      {...rest}
      style={{
        ...style,
        transform,
        transition: 'transform 0.16s cubic-bezier(0.16,1,0.3,1), border-color 0.16s ease',
        WebkitTapHighlightColor: 'transparent',
        cursor: disabled ? 'default' : 'pointer',
      }}
    >
      {children}
    </button>
  );
}
